import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState<'privacy' | 'terms'>('privacy');
  const openModal = (type: 'privacy' | 'terms') => {
    setModalContent(type);
    setModalOpen(true);
  };
  const privacyContent = <>
      <p data-id="element-123">
        <strong data-id="element-124">1. Information We Collect</strong>
        <br data-id="element-125" />
        We collect information necessary to process your purchase and deliver
        the digital product, including your name and email address. We do not
        store complete financial information.
      </p>

      <p data-id="element-126">
        <strong data-id="element-127">2. Use of Information</strong>
        <br data-id="element-128" />
        We use your information solely to deliver the product, send related
        updates, and improve our services.
      </p>

      <p data-id="element-129">
        <strong data-id="element-130">3. Data Protection</strong>
        <br data-id="element-131" />
        We implement industry-standard security measures to protect your
        personal information against unauthorized access.
      </p>

      <p data-id="element-132">
        <strong data-id="element-133">4. Cookies</strong>
        <br data-id="element-134" />
        We use essential cookies for the shopping cart functionality and
        anonymous traffic analysis.
      </p>
    </>;
  const termsContent = <>
      <p data-id="element-135">
        <strong data-id="element-136">1. Acceptance</strong>
        <br data-id="element-137" />
        By purchasing this product, you agree to these terms and conditions in
        their entirety.
      </p>

      <p data-id="element-138">
        <strong data-id="element-139">2. Digital Product</strong>
        <br data-id="element-140" />
        "The Knee Geometry Method" is a 100% digital product. No physical
        product will be shipped.
      </p>

      <p data-id="element-141">
        <strong data-id="element-142">3. Refund Policy</strong>
        <br data-id="element-143" />
        We offer a 30-day satisfaction guarantee. If you are not satisfied, you
        may request a full refund within this period.
      </p>

      <p data-id="element-144">
        <strong data-id="element-145">4. Intellectual Property</strong>
        <br data-id="element-146" />
        All content is protected by copyright. Redistribution or resale is
        strictly prohibited.
      </p>

      <p data-id="element-147">
        <strong data-id="element-148">5. Medical Disclaimer</strong>
        <br data-id="element-149" />
        The author is not responsible for misuse of the information provided.
        This guide is for educational purposes and does not replace professional
        medical advice.
      </p>
    </>;
  return <>
      <footer className="bg-[#111827] text-[#aaa] text-center py-[30px] px-[15px] text-[12px]" data-id="element-150">
        <p className="mb-4" data-id="element-151">© 2025 - The Knee Geometry Method</p>
        <div className="flex justify-center gap-6 text-[11px]" data-id="element-152">
          <button onClick={() => openModal('privacy')} className="text-gray-500 hover:text-gray-300 underline transition-colors" data-id="element-153">
            Privacy Policy
          </button>
          <button onClick={() => openModal('terms')} className="text-gray-500 hover:text-gray-300 underline transition-colors" data-id="element-154">
            Terms & Conditions
          </button>
        </div>
      </footer>

      <LegalModal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={modalContent === 'privacy' ? 'Privacy Policy' : 'Terms & Conditions'} content={modalContent === 'privacy' ? privacyContent : termsContent} data-id="element-155" />
    </>;
}